import React, { FC } from 'react';

import { t } from 'state/intl/translations';
import { theme } from 'styles/configure-theme';

import { MethodType, TextContainer } from './styled';

interface ICashMethod {
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const CashMethod: FC<ICashMethod> = ({ isDisabled, isRedesign }) => {
  const textProps = isRedesign ? { variant: 'headerTwo', fontSize: 'lg', marginTop: '$2' } : null;

  return (
    <TextContainer>
      <MethodType
        color={isDisabled ? theme.token('text-disabled') : theme.token('text-default')}
        {...textProps}
      >
        {t('cash')}
      </MethodType>
    </TextContainer>
  );
};

export default CashMethod;
